<div class="toast-container">
	<div class="title">You've been signed out</div>
	<div class="sign-back-in">
		<app-gradient-button [minHeight]="'39px'" [width]="'115px'" [fontSize]="'14px'" [cursor]="'pointer'" (buttonClick)="signBackInTapped()">
			Sign back in
		</app-gradient-button>
	</div>
</div>
